export default {
  langState: state => state.lang,
  langOptionState: state => state.langOption,
  darkModeState: state => state.layoutMode.dark,
  rtlModeState: state => state.layoutMode.rtl
}
